import type { CheckGridCellPatch } from "../types";

export function completeTogglePatch(isDone: boolean, boardUserId?: number, comment?: string | null): CheckGridCellPatch {
  // Omit board_user_id for the caller / unassigned column (subject id 0).
  const forPerson = boardUserId != null && boardUserId !== 0;
  return {
    checked: !isDone,
    applicability: "applicable",
    comment,
    ...(forPerson ? { board_user_id: boardUserId } : {})
  };
}
